<div class="component">
    <div class="component__header">Form [{{configPath}}]:</div>
    <config-controls
        #configControls
        [sections]="sections"
        [fullConfigPath]="fullConfigPath"></config-controls>
</div>
